/**
 * TipTap format command runners for RichTextComposer (CC ≤ 4).
 */

import type { Editor } from '@tiptap/core';

export type FormatCommand =
  | 'bold'
  | 'italic'
  | 'strike'
  | 'bulletList'
  | 'orderedList'
  | 'blockquote'
  | 'code'
  | 'codeBlock';

export function runFormatCommand(editor: Editor, command: FormatCommand): void {
  const chain = editor.chain().focus();
  if (command === 'bold') {
    chain.toggleBold().run();
    return;
  }
  if (command === 'italic') {
    chain.toggleItalic().run();
    return;
  }
  if (command === 'strike') {
    chain.toggleStrike().run();
    return;
  }
  runListOrBlockFormat(chain, command);
}

function runListOrBlockFormat(
  chain: ReturnType<Editor['chain']>,
  command: FormatCommand,
): void {
  if (command === 'bulletList') {
    chain.toggleBulletList().run();
    return;
  }
  if (command === 'orderedList') {
    chain.toggleOrderedList().run();
    return;
  }
  if (command === 'blockquote') {
    chain.toggleBlockquote().run();
    return;
  }
  runCodeFormat(chain, command);
}

function runCodeFormat(chain: ReturnType<Editor['chain']>, command: FormatCommand): void {
  if (command === 'code') {
    chain.toggleCode().run();
    return;
  }
  if (command === 'codeBlock') {
    chain.toggleCodeBlock().run();
  }
}
